import type { AxiosResponse } from 'axios';
import { axiosMicroservice } from 'src/api/axios';

const paymentSystemUrlMap = {
  braintree: '',
  stripe: 'stripe/subscription',
};

export type TpAddSubscription = {
  product: 'Academy' | 'Youth' | 'YouthUS';
  app?: 'Academy' | 'Youth' | 'YouthUS';
  priceId: string;
  customerId: string;
  currency: string;
  introOfferId: string;
  introOfferDuration: string;
  introOfferMustBePaid: boolean;
  cancelAtPeriodEnd: boolean;
  campaign: string;
  userId: string;
  token: string;
  email: string;
  paymentSystem?: 'braintree' | 'stripe';
};

export const buySecondSubscription = async ({
  product,
  app = 'Youth',
  priceId,
  customerId,
  currency,
  introOfferId,
  introOfferDuration,
  introOfferMustBePaid,
  cancelAtPeriodEnd,
  campaign,
  userId,
  token,
  email,
  paymentSystem = 'stripe',
}: TpAddSubscription): Promise<AxiosResponse<{ subscription_id: string }>> => {
  return await axiosMicroservice.post(`${paymentSystemUrlMap[paymentSystem]}`, {
    product,
    price_id: priceId,
    customer_id: customerId,
    currency: currency,
    intro_offer_id: introOfferId,
    intro_offer_duration: introOfferDuration,
    intro_offer_must_be_paid: introOfferMustBePaid,
    cancel_at_period_end: cancelAtPeriodEnd,
    campaign: campaign || 'undefined',
    user_id: userId,
    token,
    email,
    app,
  });
};
